import { IconFn, IconSvg } from "../createIcon";

export const UnlockSolidIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 40, height: 48 }} {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M36 22.8H3.6V44.4H36V22.8ZM0 19.2V48H39.6V19.2H0Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M3.6 22.8H36V44.4H3.6V22.8ZM24 30H15.6V37.2H24V30Z" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.3479 11.6007L34.3433 9.82491C32.1445 4.08544 26.5775 0 20.0738 0C11.6514 0 4.8 6.85141 4.8 15.2738V19.2H9.16312V15.2738C9.16312 9.25657 14.0594 4.36312 20.0738 4.36312C24.8001 4.36312 28.836 7.38684 30.3479 11.6007Z"
      fill={color}
    />
  </IconSvg>
);
